<template>
  <div class="cf-flex cf-flex--column cf-flex--gap-16 cf-padding-y-16">
    <Teleport
      defer
      to="#portal-modal-header-target"
    >
      Receipt
    </Teleport>

    <h3
      :class="['cf-title cf-title--3', {
        'cf-title--green': isOrderComplete,
        'cf-title--gray': !isOrderComplete
      }]"
    >
      {{ orderStatusContent }}
    </h3>

    <div class="cf-flex cf-flex--column cf-flex--gap-16 cf-text-align-left">
      <order-history-fulfillment-time :receipt="receipt" />

      <cf-title-separator :omit-title="true" />

      <!-- Delivery Receipt Details -->
      <delivery-receipt-fulfillment-details
        v-if="receipt.fulfillmentType === 'Delivery'"
        :receipt="receipt"
      />

      <!-- Shipping Details -->
      <shipping-receipt-fulfillment-details
        v-else-if="receipt.fulfillmentType === 'Shipping'"
        :receipt="receipt"
      />

      <!-- Dine-in Receipt Details -->
      <dine-in-receipt-fulfillment-details
        v-else-if="receipt.fulfillmentType === 'DineIn'"
        :receipt="receipt"
      />

      <!-- Room Service Receipt Details -->
      <room-service-receipt-fulfillment-details
        v-else-if="receipt.fulfillmentType === 'RoomService'"
        :receipt="receipt"
      />

      <!-- Takeout Receipt Details -->
      <takeout-receipt-fulfillment-details
        v-else
        :receipt="receipt"
        :hide-guest-arrived-cta="true"
      />

      <!-- Receipt Order Items -->
      <receipt-order-items
        :receipt="receipt"
        :is-favorite-enabled="false"
        :is-item-rating-enabled="isItemRatingEnabled"
      />

      <!-- Contact & Payment Info -->
      <receipt-contact-and-payment-info :receipt="receipt" />
    </div>
  </div>
</template>


<script>
  import { mapGetters } from 'vuex';

  import TakeoutReceiptFulfillmentDetails from '@/view/pages/order-ahead/order-receipt-page/takeout-receipt-fulfillment-details/index.vue';
  import DeliveryReceiptFulfillmentDetails from '@/view/pages/order-ahead/order-receipt-page/delivery-receipt-fulfillment-details/index.vue';
  import ShippingReceiptFulfillmentDetails from '@/view/pages/order-ahead/order-receipt-page/shipping-receipt-fulfillment-details/index.vue';
  import DineInReceiptFulfillmentDetails from '@/view/pages/order-ahead/order-receipt-page/dine-in-receipt-fulfillment-details/index.vue';
  import RoomServiceReceiptFulfillmentDetails from '@/view/pages/order-ahead/order-receipt-page/room-service-receipt-fulfillment-details/index.vue';
  import ReceiptOrderItems from '@/view/pages/order-ahead/order-receipt-page/receipt-order-items/index.vue';
  import ReceiptContactAndPaymentInfo from '@/view/pages/order-ahead/order-receipt-page/receipt-contact-and-payment-info/index.vue';

  import OrderHistoryFulfillmentTime from '../order-history-fulfillment-time/index.vue';

  import CfTitleSeparator from '@/view/components/shared/cf-title-separator/index.vue';


  export default {
    name: 'OrderHistoryReceipt',

    components: {
      TakeoutReceiptFulfillmentDetails,
      DeliveryReceiptFulfillmentDetails,
      ShippingReceiptFulfillmentDetails,
      DineInReceiptFulfillmentDetails,
      RoomServiceReceiptFulfillmentDetails,
      ReceiptOrderItems,
      ReceiptContactAndPaymentInfo,
      OrderHistoryFulfillmentTime,
      CfTitleSeparator
    },

    props: {
      receipt: {
        type: Object,
        required: true
      }
    },

    computed: {
      ...mapGetters('merchant', ['merchant']),

      isPickupType() {
        return this.receipt.fulfillmentType === 'Takeout'
          || this.receipt.fulfillmentType === 'Curbside'
          || this.receipt.fulfillmentType === 'DriveThrough';
      },

      isOrderComplete() {
        if (this.receipt.fulfillmentType === 'Delivery') {
          const deliveryDate = new Date(this.receipt.delivery.estimatedDeliveryTime);

          return deliveryDate.getTime() <= Date.now();
        }

        if (this.receipt.fulfillmentType === 'DineIn' || this.receipt.fulfillmentType === 'Shipping') {
          return true;
        }

        const pickupDate = new Date(this.receipt.pickupDate);

        return pickupDate.getTime() <= Date.now();
      },

      isItemRatingEnabled() {
        const isItemRatingEnabled = this.merchant.features['item-rating-enabled'] && this.merchant.features['order-history-receipt-rating-enabled'];

        return isItemRatingEnabled;
      },

      orderStatusContent() {
        return this.isOrderComplete
          ? 'Completed'
          : 'Not Yet Fulfilled';
      }
    }
  };
</script>
